/**
 * Carousel Product Card Title Height Alignment
 * Dynamically calculates and applies the maximum title height across all carousel items
 * to ensure price alignment
 */

function alignCarouselTitles() {
  // Find all carousel containers
  const carousels = document.querySelectorAll('.resource-list__carousel');

  carousels.forEach(carousel => {
    // Find all product title paragraphs within this carousel
    const titles = carousel.querySelectorAll('.text-block p');

    if (titles.length === 0) return;

    // Reset any previously set heights to get natural heights
    titles.forEach(title => {
      title.style.minHeight = '';
      title.style.height = '';
    });

    // Force a reflow to ensure we get accurate measurements
    carousel.offsetHeight;

    // Calculate the maximum natural height
    let maxHeight = 0;
    titles.forEach(title => {
      const height = title.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    // Apply the max height to all titles for alignment
    if (maxHeight > 0) {
      titles.forEach(title => {
        title.style.minHeight = `${maxHeight}px`;
      });
    }
  });
}

// Run on initial page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', alignCarouselTitles);
} else {
  alignCarouselTitles();
}

// Re-align on window resize (debounced)
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(alignCarouselTitles, 250);
});

// Re-align when images load (they might change layout)
window.addEventListener('load', alignCarouselTitles);
